import { NavMenuInterface } from "../interface/common.interface";

//*** NOTE
//Order of the array will determine the tab order shown in the Navigation bar

export const NAV_MENU_LIST: NavMenuInterface[] = [
  {
    levelOneId: "p_motor",
    tabUrl: "motor",
    tabTitle: "Car Insurance",
    tabIcon: "directions_car",
    levelTwo: [
      {
        url: "/motor/quotations",
        icon: "request_quote",
        title: "Quotation",
        levelTwoId: "s_motor_quotation"
      },
      // {
      //   url: "/motor/iq-quotation",
      //   icon: "request_quote",
      //   title: "Instant Quotation",
      //   levelTwoId: "s_motor_iqquotation"
      // },
      {
        url: "/motor/recent-quote-links",
        icon: "link",
        title: "Active Quote",
        levelTwoId: "s_motor_activequote"
      },
      {
        url: "/motor/issuances",
        icon: "spellcheck",
        title: "Issuance",
        levelTwoId: "s_motor_issuance"
      },
      {
        url: "/motor/issuance-issues",
        icon: "warning",
        title: "Issuance Issue",
        levelTwoId: "s_motor_issuanceissues"
      },
      {
        url: "/motor/roadtax",
        icon: "local_shipping",
        title: "Roadtax",
        levelTwoId: "s_motor_roadtax"
      },
      {
        url: "/motor/policies",
        icon: "policy",
        title: "Policies",
        levelTwoId: "s_motor_policy"
      },
      {
        url: "/motor/bulk-quotation",
        icon: "storage",
        title: "Bulk Quotation",
        levelTwoId: "s_motor_bulkquotation"
      },
      {
        url: "/motor/endorsement",
        icon: "assignment",
        title: "Endorsement",
        levelTwoId: "s_motor_endorsement"
      },
      {
        url: "/motor/early-quotation",
        icon: "access_time",
        title: "Too Early Renewals",
        levelTwoId: "s_motor_tooearly"
      },
      {
        url: "/motor/banner-upload",
        icon: "add_photo_alternate",
        title: "Banner Upload",
        levelTwoId: null // NOTE_CHECK: leave this null and get the leveltwoId from backend later when API is completed
      },
      {
        url: "/motor/campaign-setup",
        icon: "settings",
        title: "Campaign Setup",
        levelTwoId: "s_motor_eventmanagement"
      },
      {
        url: "/motor/refund",
        icon: "monetization_on",
        title: "Refund",
        levelTwoId: "s_motor_refund"
      }
    ]
  },
  {
    levelOneId: "p_motorcycle",
    tabUrl: "motorcycle",
    tabTitle: "Motorcycle Insurance",
    tabIcon: "two_wheeler",
    levelTwo: [
      {
        url: "/motorcycle/quotations",
        icon: "request_quote",
        title: "Quotation",
        levelTwoId: "s_motorcycle_quotation"
      },
      {
        url: "/motorcycle/recent-quote-links",
        icon: "link",
        title: "Active Quote",
        levelTwoId: "s_motorcycle_activequote"
      },
      {
        url: "/motorcycle/issuances",
        icon: "spellcheck",
        title: "Issuance",
        levelTwoId: "s_motorcycle_issuance"
      },
      {
        url: "/motorcycle/issuance-issues",
        icon: "warning",
        title: "Issuance Issue",
        levelTwoId: "s_motorcycle_issuanceissues"
      },
      {
        url: "/motorcycle/policies",
        icon: "policy",
        title: "Policies",
        levelTwoId: "s_motorcycle_policy"
      },
      {
        url: "/motorcycle/roadtax",
        icon: "local_shipping",
        title: "Roadtax",
        levelTwoId: "s_motorcycle_roadtax"
      },
      {
        url: "/motorcycle/early-quotation",
        icon: "access_time",
        title: "Too Early Renewals",
        levelTwoId: "s_motorcycle_tooearly"
      },
      {
        url: "/motorcycle/refund",
        icon: "monetization_on",
        title: "Refund",
        levelTwoId: "s_motorcycle_refund"
      }
    ]
  },
  {
    levelOneId: "p_digitalrep",
    tabUrl: "dealer",
    tabTitle: "Digital Rep Car/Lorry",
    tabIcon: "add_business",
    levelTwo: [
      {
        url: "/dealer/quotations",
        icon: "request_quote",
        title: "Quotation",
        levelTwoId: "s_digitalrep_quotation"
      },
      {
        url: "/dealer/recent-quote-links",
        icon: "link",
        title: "Active Quote",
        levelTwoId: "s_digitalrep_activequote"
      },
      {
        url: "/dealer/issuances",
        icon: "spellcheck",
        title: "Issuance",
        levelTwoId: "s_digitalrep_issuance"
      },
      {
        url: "/dealer/issuance-issues",
        icon: "warning",
        title: "Issuance Issue",
        levelTwoId: "s_digitalrep_issuanceissues"
      },
      {
        url: "/dealer/policies",
        icon: "policy",
        title: "Policies",
        levelTwoId: "s_digitalrep_policy"
      },
      {
        url: "/dealer/endorsement",
        icon: "assignment",
        title: "Endorsement",
        levelTwoId: "s_digitalrep_endorsement"
      },
      {
        url: "/dealer/roadtax",
        icon: "local_shipping",
        title: "Roadtax",
        levelTwoId: "s_digitalrep_roadtax"
      },
      {
        url: "/dealer/bulk-quotation",
        icon: "storage",
        title: "Bulk Quotation",
        levelTwoId: "s_digitalrep_bulkquotation"
      }
    ]
  },
  ,
  {
    levelOneId: null,
    tabUrl: "dealermotorcycle",
    tabTitle: "Digital Rep Motorcycle",
    tabIcon: "add_business",
    levelTwo: [
      {
        url: "/dealermotorcycle/quotations",
        icon: "request_quote",
        title: "Quotation",
        levelTwoId: null
      },
      {
        url: "/dealermotorcycle/recent-quote-links",
        icon: "link",
        title: "Active Quote",
        levelTwoId: null
      },
      {
        url: "/dealermotorcycle/issuances",
        icon: "spellcheck",
        title: "Issuance",
        levelTwoId: null
      },
      {
        url: "/dealermotorcycle/issuance-issues",
        icon: "warning",
        title: "Issuance Issue",
        levelTwoId: null
      },
      {
        url: "/dealermotorcycle/policies",
        icon: "policy",
        title: "Policies",
        levelTwoId: null
      },
      {
        url: "/dealermotorcycle/roadtax",
        icon: "local_shipping",
        title: "Roadtax",
        levelTwoId: null
      },
      {
        url: "/dealermotorcycle/early-quotation",
        icon: "access_time",
        title: "Too Early Renewals",
        levelTwoId: null
      },
      {
        url: "/dealermotorcycle/bulk-quotation",
        icon: "storage",
        title: "Bulk Quotation",
        levelTwoId: null
      }
    ]
  },
  {
    levelOneId: "p_claims",
    tabUrl: "claims",
    tabTitle: "Claims",
    tabIcon: "monetization_on",
    levelTwo: [
      {
        url: "/claims/rider/foodpanda",
        icon: "sports_motorsports",
        title: "Rider - FoodPanda",
        levelTwoId: "s_claims_riderprotectionfp"
      },
      {
        url: "/claims/rider/shopeefood",
        icon: "sports_motorsports",
        title: "Rider - ShopeeFood",
        levelTwoId: "s_claims_riderprotectionsf"
      },
      {
        url: "/claims/rider/spxexpress",
        icon: "sports_motorsports",
        title: "Rider - ShopeeXpress",
        // TODO: levelTwoId should be "s_claims_riderprotectionsx" but due to access token size limitations, temporary set to shopeefood id
        levelTwoId: "s_claims_riderprotectionsf"
      },
      {
        url: "/claims/ecommerce",
        icon: "shield",
        title: "DP - Shopee",
        levelTwoId: "s_claims_damageprotection"
      },
      {
        url: "/claims/maxis",
        icon: "shield",
        title: "DP - Maxis",
        levelTwoId: null // TODO: Due to access token size limitations, temporary set to null
      },
      {
        url: "/claims/flash",
        icon: "shield",
        title: "Parcel - Flash Express",
        levelTwoId: null // TODO: Due to access token size limitations, temporary set to null
      },
      {
        url: "/claims/extended-warranty",
        icon: "monitor_heart",
        title: "EWEP - Shopee AIA",
        levelTwoId: "s_claims_extendedwarranty"
      },
      {
        url: "/claims/extended-warranty-bs",
        icon: "monitor_heart",
        title: "EWEP - Shopee Sompo",
        levelTwoId: "s_claims_extendedwarranty"
      },
      {
        url: "/claims/ashleyhomes",
        icon: "chair",
        title: "FP - Ashley Homes",
        levelTwoId: null // TODO: Due to access token size limitations, temporary set to null
      },
      {
        url: "/claims/tts-tmim",
        icon: "shield",
        title: "Protection - TTS TMIM",
        levelTwoId: null
      },
      {
        url: "/claims/tts-chubb",
        icon: "shield",
        title: "Protection - TTS Chubb",
        levelTwoId: null
      },
      {
        url: "/claims/tts-tune",
        icon: "shield",
        title: "Protection - TTS Tune",
        levelTwoId: null
      }
    ]
  },
  {
    levelOneId: "p_damageprotection",
    tabUrl: "damageprotection",
    tabTitle: "Damage Protection",
    tabIcon: "shield",
    levelTwo: [
      {
        url: "/damageprotection/maxis",
        icon: "table_chart",
        title: "Maxis",
        // TODO: levelTwoId should be "s_damageprotection_maxis" but due to access token size limitations, temporary set to shopee id
        levelTwoId: "s_damageprotection_shopee"
      },
      {
        url: "/damageprotection/shopee",
        icon: "table_chart",
        title: "Shopee",
        levelTwoId: "s_damageprotection_shopee",
        isDisabled: true
      }
    ]
  },
  {
    levelOneId: "p_extendedwarranty",
    tabUrl: "extendedwarranty",
    tabTitle: "Extended Warranty",
    tabIcon: "monitor_heart",
    levelTwo: [
      {
        url: "/extendedwarranty/shopee",
        icon: "table_chart",
        title: "Shopee - AIA",
        levelTwoId: "s_extendedwarranty_shopee"
      },
      {
        url: "/extendedwarranty/lulu",
        icon: "table_chart",
        title: "LuLu",
        levelTwoId: null
      },
      {
        url: "/extendedwarranty/sompo",
        icon: "table_chart",
        title: "Shopee - Sompo",
        levelTwoId: "s_extendedwarranty_shopee"
      },
      {
        url: "/extendedwarranty/tbm",
        icon: "table_chart",
        title: "TBM - Sompo",
        levelTwoId: null
      }
    ]
  },
  {
    levelOneId: null, // TODO: Due to access token size limitations, temporary set to null
    tabUrl: "parcelprotection",
    tabTitle: "Parcel Protection",
    tabIcon: "orders",
    levelTwo: [
      {
        url: "/parcelprotection/flash",
        icon: "table_chart",
        title: "Flash Express",
        levelTwoId: null // TODO: Due to access token size limitations, temporary set to null
      }
    ],
    customClass: "material-symbols-outlined"
  },
  {
    // TODO: create new access token for levelOneId
    levelOneId: null,
    tabUrl: "personalprotection",
    tabTitle: "Personal Protection",
    tabIcon: "shield",
    levelTwo: [
      {
        url: "/personalprotection/directlending",
        icon: "table_chart",
        title: "Direct Lending",
        levelTwoId: null
      },
      {
        url: "/personalprotection/hello1010",
        icon: "table_chart",
        title: "Hello1010",
        levelTwoId: null
      }
    ]
  },
  {
    // TODO: create new access token for levelOneId
    levelOneId: null,
    tabUrl: "furnitureprotection",
    tabTitle: "Furniture Protection",
    tabIcon: "store",
    levelTwo: [
      {
        url: "/ashleyhomes/main",
        icon: "table_chart",
        title: "Ashley Homes",
        levelTwoId: null
      }
    ]
  },
  {
    // TODO: create new access token for levelOneId
    levelOneId: null,
    tabUrl: "partner",
    tabTitle: "Partner Platform",
    tabIcon: "store",
    levelTwo: [
      {
        url: "/partner",
        icon: "table_chart",
        title: "Partner",
        levelTwoId: null
      }
    ]
  },
  {
    levelOneId: "p_riderprotection",
    tabUrl: "rideraccident",
    tabTitle: "Rider Accident",
    tabIcon: "sports_motorsports",
    levelTwo: [
      {
        url: "/rideraccident/foodpanda",
        icon: "table_chart",
        title: "FoodPanda",
        levelTwoId: "s_riderprotection_fp"
      },
      {
        url: "/rideraccident/shopeefood",
        icon: "table_chart",
        title: "ShopeeFood",
        levelTwoId: "s_riderprotection_sf"
      },
      {
        url: "/rideraccident/spxexpress",
        icon: "table_chart",
        title: "ShopeeXpress",
        // TODO: levelTwoId should be "s_riderprotection_sx" but due to access token size limitations, temporary set to shopeefood id
        levelTwoId: "s_riderprotection_sf"
      }
    ]
  },
  {
    levelOneId: "p_employeebenefits",
    tabUrl: "employeebenefits",
    tabTitle: "Employee Benefits",
    tabIcon: "business",
    levelTwo: [
      {
        url: "/employeebenefits/main",
        icon: "table_chart",
        title: "Clients Profile & Billing",
        levelTwoId: "s_employeebenefits_clients"
      },
      {
        url: "/employeebenefits/employee-movement",
        icon: "person",
        title: "Employee Movement",
        levelTwoId: "s_employeebenefits_movement"
      }
    ]
  },
  {
    levelOneId: "p_externalaccounts",
    tabUrl: "accounts",
    tabTitle: "External User Accounts",
    tabIcon: "person",
    levelTwo: [
      {
        url: "/accounts/riders/foodpanda",
        icon: "sports_motorsports",
        title: "FoodPanda",
        levelTwoId: "s_externalaccounts_fp"
      },
      {
        url: "/accounts/riders/shopeefood",
        icon: "sports_motorsports",
        title: "ShopeeFood",
        levelTwoId: "s_externalaccounts_sf"
      },
      {
        url: "/accounts/ecommerce",
        icon: "local_mall",
        title: "Shopee",
        levelTwoId: "s_externalaccounts_shopee"
      },
      {
        url: "/accounts/motor",
        icon: "directions_car",
        title: "Motor Dashboard",
        levelTwoId: "s_externalaccounts_motorpartner"
      },
      {
        url: "/accounts/generate-coc",
        icon: "description",
        title: "Confirmation of Cover",
        levelTwoId: "s_externalaccounts_generatecoc"
      }
    ]
  },
  {
    levelOneId: null,
    tabUrl: "website-configuration",
    tabTitle: "Website Configuration",
    tabIcon: "build",
    levelTwo: [
      {
        url: "/config/post-editor",
        icon: "edit",
        title: "Post Editor",
        levelTwoId: null
      },
      {
        url: "/config/banner-upload",
        icon: "add_photo_alternate",
        title: "Banner Upload",
        levelTwoId: null
      },
      {
        url: "/config/tnc",
        icon: "edit",
        title: "Tnc Upload",
        levelTwoId: null
      }
    ]
  },
  {
    levelOneId: "p_report",
    tabUrl: "reports",
    tabTitle: "Reports",
    tabIcon: "equalizer",
    levelTwo: [
      {
        url: "/report/ops-productivity",
        icon: "equalizer",
        title: "OPS Productivity Report",
        levelTwoId: "s_report_ops"
      },
      {
        url: "/report/sla-report",
        icon: "equalizer",
        title: "SLA Report",
        levelTwoId: "s_report_sla"
      }
    ]
  },
  {
    levelOneId: "p_commercialmanagement",
    tabUrl: "commercial-management",
    tabTitle: "Commercial Management",
    tabIcon: "attach_money",
    levelTwo: [
      {
        url: "/commercial-management/view-billing",
        icon: "attach_money",
        title: "Billing",
        levelTwoId: "s_commercialmanagement_billing"
      }
    ]
  },
  {
    levelOneId: null,
    tabUrl: "master-setup",
    tabTitle: "Master Setup",
    tabIcon: "settings",
    levelTwo: [
      {
        url: "/master-setup/postcode",
        icon: "location_on",
        title: "Postcode",
        levelTwoId: null
      },
      {
        url: "/master-setup/special-roadtax",
        icon: "local_shipping",
        title: "Roadtax Rate Setup",
        levelTwoId: "s_mastersetup_roadtaxratesetup"
      }
    ]
  },
  {
    levelOneId: null,
    tabUrl: "announcement",
    tabTitle: "Announcement",
    tabIcon: "announcement",
    levelTwo: [
      {
        url: "/announcement/b2c",
        icon: "announcement",
        title: "B2C Announcement",
        levelTwoId: null
      },
      {
        url: "/announcement/dr",
        icon: "announcement",
        title: "Digital Rep Announcement",
        levelTwoId: null
      }
    ]
  },
  {
    levelOneId: null,
    tabUrl: "promo-code",
    tabTitle: "Promo Code Generation",
    tabIcon: "confirmation_number",
    levelTwo: [
      {
        url: "/promo-code/motor",
        icon: "equalizer",
        title: "B2B / B2C / B2B2C",
        levelTwoId: null
      },
      {
        url: "/promo-code/dealer",
        icon: "equalizer",
        title: "Digital Rep",
        levelTwoId: null
      },
      {
        url: "/promo-code/motor-reward-voucher",
        icon: "equalizer",
        title: "Reward Voucher",
        levelTwoId: null
      }
    ]
  },
  {
    levelOneId: null,
    tabUrl: "vouchers",
    tabTitle: "Vouchers Management",
    tabIcon: "confirmation_number",
    levelTwo: [
      {
        url: "vouchers/cash-vouchers",
        icon: "money",
        title: "Cash Vouchers",
        levelTwoId: null
      },
      {
        url: "vouchers/external-vouchers",
        icon: "money",
        title: "External Vouchers",
        levelTwoId: null
      }
    ]
  },
  {
    levelOneId: "p_settings",
    tabUrl: "settings",
    tabTitle: "User settings",
    tabIcon: "settings",
    levelTwo: [
      {
        url: "/settings/users",
        icon: "people",
        title: "User access",
        levelTwoId: "s_settings_useraccess"
      },
      // {
      //   url: "/settings/myaccount",
      //   icon: "person",
      //   title: "My account",
      //   levelTwoId: null
      // },
      {
        url: "/settings/roles",
        icon: "person",
        title: "Role",
        levelTwoId: "s_settings_role"
      },
      {
        url: "/settings/password-policy-config",
        icon: "settings",
        title: "Password Policy Configuration",
        levelTwoId: "s_settings_passwordpolicy"
      }
    ]
  }
];
